import { createSlice } from '@reduxjs/toolkit'
import {getFactoryRentTypes} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  rentTypes: [], 
  loading: "idle",
  error: null }

const factoryRentTypesSlice = createSlice({
  name: 'factoryRentTypes',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryRentTypes.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryRentTypes.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.rentTypes = action.payload
      
    },
    [getFactoryRentTypes.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryRentTypesSlice.actions;
export default factoryRentTypesSlice.reducer
